// extracted by mini-css-extract-plugin
export default {"radio":"MGInputRadioButton_radio__ncCEP","input":"MGInputRadioButton_input__kpUnB","visual":"MGInputRadioButton_visual__ksrp3","inner":"MGInputRadioButton_inner__9Zvcs"};